import type { ObjectView, TableModel } from '../model/table';

/**
 * The caption of an inspected object's details: "Only you can see this" only for an object in an owner-visible zone that belongs to the
 * viewer's own seat (the cards a pick offers, a hand). An owner-visible zone of another seat, or a viewer without a seat, keeps the
 * public caption.
 */
export function detailsLabelFor(table: Pick<TableModel, 'zones' | 'selfSeat'>, object: Pick<ObjectView, 'zoneId'> | undefined): string {
  const zone = object ? table.zones.find(z => z.id === object.zoneId) : undefined;
  return zone && zone.visibility === 'owner' && !!table.selfSeat && zone.owner === table.selfSeat ? 'Only you can see this' : 'Public details';
}
